// extracted by mini-css-extract-plugin
export var chip = "_5h-0";
export var filterDropdown = "_5h-5";
export var filterItem = "_5h-6";
export var icon = "_5h-1";
export var removeButton = "_5h-3";
export var removeIcon = "_5h-4";
export var separator = "_5h-2";